// Styled components for Home page
import styled from "@emotion/styled";

export const HomeContainer = styled.div`
  text-align: center;
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
`;

export const Title = styled.h1`
  font-size: 3rem;
  margin-top: 5rem;
  color: #282c34;
`;

export const MissionStatement = styled.p`
  font-size: 1.25rem;
  margin: 1rem auto 2rem;
  max-width: 600px;
  color: #555;
`;

export const PartnersSection = styled.div`
  background-color: #f9f9f9;
  padding: 3rem 1rem;
`;

export const SectionTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
`;

export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
`;

export const Logo = styled.img<{ width?: string }>` // Accept an optional width prop
  width: ${(props) => props.width || '100px'}; // Default width is 100px if no prop is passed
  height: auto;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
  }
`;
